module.exports = __webpack_public_path__ + "img/ERGO_Icon_black_Whatsapp.57a1cd71.svg";